import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from '../Common';
import Typography from '../Typography';

const InteractiveCardWrapper = styled.div<{ highlightBorder?: boolean; activeBorderColor?: string }>`
  background: var(--sys-color--surface);
  border-radius: 16px;
  width: 100%;
  box-sizing: border-box;

  ${({ highlightBorder, activeBorderColor }) =>
    highlightBorder &&
    `
      border: 2px solid ${activeBorderColor || 'var(--sys-color--primary)'};
    `}

  > a {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    width: 100%;
  }
`;

const CardLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
`;

const TruncatedTypography = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  margin-top: 4px;
`;

interface ItemGridProps {
  photo: React.ReactNode;
  title: string;
  subtitle?: string;
  linkTo: string;
  pageDirection?: 'FORWARD' | 'BACKWARD';
  highlightBorder?: boolean;
  activeBorderColor?: string;
  onClick?: () => void;
  id?: string;
}

export const ItemGrid: FC<ItemGridProps> = ({
  photo,
  title,
  subtitle,
  linkTo,
  pageDirection = 'FORWARD',
  highlightBorder = false,
  activeBorderColor,
  onClick,
  id,
}) => {
  return (
    <InteractiveCardWrapper highlightBorder={highlightBorder} activeBorderColor={activeBorderColor}>
      <CardLink
        to={linkTo}
        pageDirection={pageDirection}
        id={id}
        aria-label={id}
        onClick={onClick}
      >
        {photo}
        <TruncatedTypography variant="labelLarge" align="center" color="var(--sys-color--on-surface)">
          {title}
        </TruncatedTypography>
        {subtitle && (
          <Typography variant="bodySmall" align="center" color="var(--sys-color--on-surface-variant)">
            {subtitle}
          </Typography>
        )}
      </CardLink>
    </InteractiveCardWrapper>
  );
};

export default ItemGrid;
